import React from 'react';
import { cn } from '../lib/utils';

interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ 
  children, 
  className 
}) => {
  return (
    <section 
      className={cn(
        'bg-tg-bg rounded-[20px] p-6 flex flex-col gap-6 relative overflow-hidden',
        'shadow-[0_8px_32px_rgba(0,0,0,0.08)]',
        'max-[360px]:p-5 max-[360px]:gap-5',
        className
      )}
      style={{ 
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08), inset 0 0 0 1px rgba(255, 0, 128, 0.1)' 
      }}
    >
      {/* Градиентный фон */}
      <div 
        className="absolute inset-0 z-[1] pointer-events-none opacity-50"
        style={{
          background: 'radial-gradient(circle at top left, rgba(255, 0, 128, 0.08), transparent 50%), radial-gradient(circle at bottom right, rgba(255, 107, 0, 0.08), transparent 50%)'
        }}
      />
      <div className="relative z-[2]">
        {children}
      </div>
    </section>
  );
};

